import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-rech-sol',
  templateUrl: './modal-rech-sol.component.html',
  styleUrls: ['./modal-rech-sol.component.css']
})
export class ModalRechSolComponent implements OnInit {
  form: FormGroup;
  params: any;
  private lovs:string = environment.lovs;
  private rechazosol:string = environment.rechazosol;

  motivosLov: any[] = [];

  constructor(private http: HttpClient, private modalService: NgbModal, private fb: FormBuilder, public parametroAccionService : ParametroAccionService, private toastr: ToastrService) {
    this.form = this.fb.group({
      motivo: []
    });
    this.params = this.parametroAccionService.obtenerDatos()[0];
    this.obtenerMotivos();
  }

  ngOnInit(): void {
  }

  onCloseModalR() {
    this.modalService.dismissAll();
  }

  obtenerMotivos() {
    // Realiza la llamada al servicio HTTP para obtener motivos
    this.http.post<any>(this.lovs, { 
      codigo_lista: 5,
      codigo_region: "",
    }).subscribe((data: any) => {
      //console.log(data);
      //console.log(data.Resultado);
      this.motivosLov = data.Resultados;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  onSubmit() {
    console.log("rutEmp"+this.params.RUT_EMPRESA);
    console.log("rutRep"+this.params.RUT_REPRESENTANTE);
    console.log("sol"+this.params.SEQ_NRO_SOLICITUD_CDG);
    this.http.post<any>(this.rechazosol, { 
      rut_empresa: this.params.RUT_EMPRESA,
      rut_representante_legal: this.params.RUT_REPRESENTANTE,
      nro_solicitud: this.params.SEQ_NRO_SOLICITUD_CDG,
      codigo_rechazo: this.form.get('motivo').value
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.toastr.success("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" rechazada correctamente.");
          this.modalService.dismissAll();
        }else{
          this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
          this.modalService.dismissAll();
        }
      }else{
        this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
        this.modalService.dismissAll();
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      this.modalService.dismissAll();
    });
  }
}
